import useScrollReveal from '../hooks/useScrollReveal';

export default function SectionHeader({ tag, title, desc, id, dark = false }) {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="reveal" style={{ textAlign: 'center', marginBottom: '2.5rem' }} id={id}>
      {tag && (
        <span className="heading-sub" style={{
          color: dark ? '#ffffff' : 'var(--text-muted)',
          display: 'block', marginBottom: '0.5rem',
        }}>{tag}</span>
      )}
      <h2 className="heading-display" style={{
        fontSize: 'clamp(2rem,4vw,3.5rem)',
        color: dark ? '#fff' : 'var(--text)', marginBottom: '0.75rem',
      }}>{title}</h2>
      {desc && (
        <p className="text-body" style={{
          color: dark ? 'rgba(255,255,255,0.7)' : 'var(--text-secondary)',
          maxWidth: '500px', margin: '0 auto'
        }}>{desc}</p>
      )}
    </div>
  );
}
